// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,500;1,400;1,500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.project_table {
  overflow-y: auto;
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  white-space: nowrap;
  background-color: #ffffff;
}
.project_table table {
  table-layout: fixed;
}
.project_table th {
  overflow: hidden;
  white-space: nowrap; /* Запрет переноса текста в ячейках */
  overflow: hidden; /* Скрываем излишки текста */
  text-overflow: ellipsis;
}
.project_table td {
  font-weight: 400;
  overflow: hidden;
  text-align: right;
  align-items: left;
  padding: 3px 5px;
  border-right: 0.02px solid rgba(88, 89, 93, 0.2941176471);
}
.project_table td:last-child {
  border-right: 0;
  text-align: center;
  justify-content: center;
  align-items: center;
}

@media screen and (min-width: 1024px) and (max-width: 1439px) {
  .kpf_table_overflow {
    width: 100em;
  }
}

.block_table {
  display: inline-block;
  border-spacing: 0;
}
.block_table .dnd_theader {
  position: sticky;
  top: 0;
  background-color: #ffffff;
  z-index: 2;
}
.block_table .dnd_theader .th {
  background: #dae1ec;
}
.block_table .tr :last-child .td {
  border-bottom: 1px solid rgba(88, 89, 93, 0.2078431373);
}
.block_table .th,
.block_table .td {
  text-align: right;
  margin: 0;
  padding: 0.5rem;
  border-bottom: 1px solid rgba(88, 89, 93, 0.2078431373);
  border-right: 1px solid rgba(88, 89, 93, 0.2078431373);
  position: relative;
}
.block_table .th .disable,
.block_table .td .disable {
  color: rgba(79, 81, 82, 0.3490196078);
  background-color: rgba(82, 82, 82, 0.0509803922);
}
.block_table .th :last-child,
.block_table .td :last-child {
  border-right: 0;
  border-bottom: 1px solid rgba(88, 89, 93, 0.2078431373);
}
.block_table .th.th_res,
.block_table .td.th_res {
  width: 1.7em;
}
.block_table .th .resizer,
.block_table .td .resizer {
  background: #f9f9f9;
  width: 0.4em;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  transform: translateX(50%);
  z-index: 1;
  touch-action: none;
}
.block_table .th .resizer.isResizing,
.block_table .td .resizer.isResizing {
  background: rgb(88, 168, 218);
}
.block_table .item_selected {
  font-weight: 550;
  background-color: rgba(66, 108, 166, 0.0470588235);
}
.block_table .th {
  text-align: center;
}
.block_table .td {
  font-weight: 400;
}

.project_list {
  max-width: 100%;
  height: 100%;
  overflow-x: hidden;
  background: #ffffff;
  background: #ffffff;
  border-bottom: 0;
  position: relative;
}
.project_list.scrollX {
  overflow-x: auto;
}
.project_list tr:nth-child(even) {
  background-color: rgba(233, 241, 251, 0.4);
}
.project_list tr:nth-child(odd) {
  background-color: white;
}
.project_list tr:last-child td {
  border-bottom: 0.02px solid rgba(88, 89, 93, 0.2941176471);
}
.project_list tbody tr td {
  height: 5em;
}
.project_list:focus {
  outline: none;
}

.project_list_kp {
  max-width: 100%;
  height: 100%;
  overflow-x: hidden;
  background: #ffffff;
  margin-bottom: 5px;
  background: #ffffff;
  border: 1px solid rgba(88, 89, 93, 0.2078431373);
  border-bottom: 0;
  position: relative;
}
.project_list_kp.scrollX {
  overflow-x: scroll;
}
.project_list_kp .kpf_table_tr:hover {
  background-color: rgba(66, 108, 166, 0.1843137255);
}

.row-even {
  background-color: rgba(233, 241, 251, 0.4);
}

.row-odd {
  background-color: white;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 15px rgba(103, 149, 187, 0.566);
}

::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 15px rgba(103, 149, 187, 0.486);
}

.radio_container {
  display: flex;
  justify-content: center;
}

.circules_box {
  width: 14px;
  height: 14px;
  position: relative;
  -webkit-user-select: none;
  user-select: none;
}
.circules_box .circule1 {
  position: absolute;
  top: 0;
  left: 0;
  height: 14px;
  width: 14px;
  background-color: #eee;
  border-radius: 50%;
}
.circules_box .circule2 {
  position: absolute;
  top: 3.3px;
  left: 3.3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.availability_circule_box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin: 0 10px;
}
.availability_circule_box .outer_circle {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: content-box;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: white;
  border: 1px solid rgba(66, 108, 166, 0.368627451);
}
.availability_circule_box .outer_circle .inner_circle {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.item_selected td {
  text-decoration: underline;
  font-weight: 550;
}

td {
  white-space: nowrap; /* Запрет переноса текста на новую строку */
  overflow: hidden; /* Скрытие текста, выходящего за пределы ячейки */
  text-overflow: ellipsis;
}

.table {
  max-width: 48vw;
  display: inline-block;
  border-spacing: 0;
}
.table .tr :last-child .td {
  border-bottom: 0;
}
.table .th,
.table .td {
  margin: 0;
  padding: 0.5rem;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
  position: relative;
}
.table .th :last-child,
.table .td :last-child {
  border-right: 0;
}
.table .th .resizer,
.table .td .resizer {
  display: inline-block;
  background: blue;
  width: 5px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  transform: translateX(50%);
  z-index: 1;
  touch-action: none;
}
.table .th .resizer.isResizing,
.table .td .resizer.isResizing {
  background: red;
}

.table_container {
  max-width: 50vw;
}

thead {
  width: 100%;
  position: sticky;
  height: auto;
  top: 0;
  background: white;
  z-index: 50;
  overflow: auto;
  border-bottom: 0.01px solid rgba(88, 89, 93, 0.2941176471);
  border-collapse: separate;
}
thead th {
  border-collapse: separate;
  font-style: normal;
  font-weight: 500;
  color: #426ba6;
  align-items: center;
  text-align: center;
  border-right: 0.01px solid rgba(88, 89, 93, 0.2941176471);
  border-bottom: 0.01px solid rgba(88, 89, 93, 0.2941176471);
}
thead th:last-child {
  border-right: 0;
}

table thead {
  border-collapse: separate;
}
table tbody {
  border-collapse: collapse;
}

.table_with_bb {
  max-width: 100%;
  overflow-x: scroll;
  background: #ffffff;
  margin-bottom: 5px;
  background: #ffffff;
  border: 1px solid rgba(88, 89, 93, 0.2078431373);
  border-bottom: 0;
  position: relative;
}
.table_with_bb thead {
  height: 1.5em;
}
.table_with_bb thead tr {
  background-color: rgba(66, 108, 166, 0.1843137255);
}
.table_with_bb table tr {
  border-bottom: 1px solid rgba(66, 108, 166, 0.231372549);
}
.table_with_bb table tr:hover {
  background-color: rgba(66, 108, 166, 0.1843137255);
}
.table_with_bb table tr:last-child {
  border-bottom: 0;
}

.table_dnd_container {
  overflow-x: scroll;
}
.table_dnd_container .project_list {
  overflow-x: scroll;
}

.table_xscroll__container .project_list {
  overflow-x: auto;
}`, "",{"version":3,"sources":["webpack://./src/Components/App/style/List.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAKhB;EACE,gBAAA;EAEA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AAHF;AAKE;EACE,mBAAA;AAHJ;AAME;EACE,gBAAA;EACA,mBAAA,EAAA,qCAAA;EACA,gBAAA,EAAA,4BAAA;EACA,uBAAA;AAJJ;AAOE;EAEE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yDAAA;AANJ;AAOI;EACE,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AALN;;AAmCE;EADF;IAEI,YAAA;EA/BF;AACF;;AAkCA;EACE,qBAAA;EACA,iBAAA;AA/BF;AAoCE;EACE,gBAAA;EACA,MAAA;EAGA,yBAAA;EACA,UAAA;AApCJ;AAqCI;EACE,mBAAA;AAnCN;AA4CM;EACE,uDAAA;AA1CR;AA+CE;;EAEE,iBAAA;EACA,SAAA;EACA,eAAA;EACA,uDAAA;EACA,sDAAA;EAEA,kBAAA;AA9CJ;AA+CI;;EACE,qCAAA;EACA,gDAAA;AA5CN;AA8CI;;EACE,eAAA;EACA,uDAAA;AA3CN;AA6CI;;EACE,YAAA;AA1CN;AA6CI;;EAEE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,0BAAA;EACA,UAAA;EAEA,kBAAA;AA5CN;AA8CM;;EACE,6BAAA;AA3CR;AA+CE;EAGE,gBAAA;EACA,kDAAA;AA/CJ;AAkDE;EACE,kBAAA;AAhDJ;AAmDE;EAEE,gBAAA;AAlDJ;;AAsDA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EAEA,mBAAA;EAEA,gBAAA;EACA,kBAAA;AArDF;AAsDE;EACE,gBAAA;AApDJ;AAsDE;EAEE,0CAAA;AArDJ;AAwDE;EACE,uBAAA;AAtDJ;AAyDI;EACE,0DAAA;AAvDN;AAiEM;EACE,WAAA;AA/DR;AAmEE;EACE,aAAA;AAjEJ;;AAqEA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gDAAA;EACA,gBAAA;EACA,kBAAA;AAlEF;AAmEE;EACE,kBAAA;AAjEJ;AAoEE;EACE,kDAAA;AAlEJ;;AAqEA;EACE,0CAAA;AAlEF;;AAqEA;EACE,uBAAA;AAlEF;;AAqEA;EACE,UAAA;AAlEF;;AAoEA;EACE,qDAAA;AAjEF;;AAmEA;EACE,qDAAA;AAhEF;;AAkEA;EACE,aAAA;EACA,uBAAA;AA/DF;;AAiEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EAGA,iBAAA;AA9DF;AAgEE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AA9DJ;AAgEE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AA9DJ;;AAkEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AA/DF;AAiEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,uBAAA;EAEA,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,uBAAA;EACA,iDAAA;AAjEJ;AAmEI;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AAjEN;;AAuEE;EACE,0BAAA;EACA,gBAAA;AApEJ;;AAwEA;EACE,mBAAA,EAAA,2CAAA;EACA,gBAAA,EAAA,iDAAA;EACA,uBAAA;AArEF;;AAwEA;EACE,eAAA;EACA,qBAAA;EACA,iBAAA;AArEF;AA0EM;EACE,gBAAA;AAxER;AA6EE;;EAEE,SAAA;EACA,eAAA;EACA,8BAAA;EACA,6BAAA;EACA,kBAAA;AA3EJ;AA6EI;;EACE,eAAA;AA1EN;AA6EI;;EACE,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,0BAAA;EACA,UAAA;EAEA,kBAAA;AA3EN;AA6EM;;EACE,eAAA;AA1ER;;AAgFA;EACE,eAAA;AA7EF;;AAgFA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,MAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,0DAAA;EACA,yBAAA;AA7EF;AA8EE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EAEA,yDAAA;EACA,0DAAA;AA7EJ;AA8EI;EACE,eAAA;AA5EN;;AAiFE;EACE,yBAAA;AA9EJ;AAgFE;EACE,yBAAA;AA9EJ;;AAkFA;EACE,eAAA;EAEA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gDAAA;EACA,gBAAA;EACA,kBAAA;AAhFF;AAkFE;EACE,aAAA;AAhFJ;AAiFI;EACE,kDAAA;AA/EN;AAmFI;EACE,wDAAA;AAjFN;AAkFM;EACE,kDAAA;AAhFR;AAkFM;EACE,gBAAA;AAhFR;;AAsFA;EAGE,kBAAA;AArFF;AAkGE;EACE,kBAAA;AAhGJ;;AAoGE;EACE,gBAAA;AAjGJ","sourcesContent":["// @import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');\n// @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;1,500&display=swap');\n\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,500;1,400;1,500&display=swap\");\n\n.project_table {\n  overflow-y: auto;\n\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  white-space: nowrap;\n  background-color: #ffffff;\n\n  table {\n    table-layout: fixed;\n  }\n\n  th {\n    overflow: hidden;\n    white-space: nowrap; /* Запрет переноса текста в ячейках */\n    overflow: hidden; /* Скрываем излишки текста */\n    text-overflow: ellipsis;\n  }\n\n  td {\n    // font-style: italic;\n    font-weight: 400;\n    overflow: hidden;\n    text-align: right;\n    align-items: left;\n    padding: 3px 5px;\n    border-right: 0.02px solid #58595d4b;\n    &:last-child {\n      border-right: 0;\n      text-align: center;\n      justify-content: center;\n      align-items: center;\n      //\n    }\n  }\n\n  // tr {\n  //   height: 10px;\n  // }\n}\n\n// .kpf_table_overflow {\n//   @media screen and (min-width: 1024px) and (max-width: 1439px) {\n//     overflow-x: scroll;\n//   }\n// }\n// .kpf_table_table_width {\n//   width: 120em;\n//   @media screen and (min-width: 1024px) {\n//     height: 10em;\n//   }\n//   @media screen and (min-width: 1440px) {\n//     height: 15em;\n//     width: 100%;\n//   }\n//   @media screen and (min-width: 1805px) {\n//     height: 24em;\n//   }\n// }\n\n.kpf_table_overflow {\n  @media screen and (min-width: 1024px) and (max-width: 1439px) {\n    width: 100em;\n  }\n}\n\n.block_table {\n  display: inline-block;\n  border-spacing: 0;\n  // border: 1px solid black;\n  // width: 500px;\n  // position: relative;\n\n  .dnd_theader {\n    position: sticky;\n    top: 0;\n    // width: 100%;\n    // max-width: inherit;\n    background-color: #ffffff;\n    z-index: 2;\n    .th {\n      background: #dae1ec;\n    }\n  }\n  // .dnd_tbody {\n  //   // margin-top: 2em;\n  // }\n\n  .tr {\n    :last-child {\n      .td {\n        border-bottom: 1px solid #58595d35;\n      }\n    }\n  }\n\n  .th,\n  .td {\n    text-align: right;\n    margin: 0;\n    padding: 0.5rem;\n    border-bottom: 1px solid #58595d35;\n    border-right: 1px solid #58595d35;\n\n    position: relative;\n    .disable {\n      color: #4f515259;\n      background-color: #5252520d;\n    }\n    :last-child {\n      border-right: 0;\n      border-bottom: 1px solid #58595d35;\n    }\n    &.th_res {\n      width: 1.7em;\n    }\n\n    .resizer {\n      // display: inline-block;\n      background: #f9f9f9;\n      width: 0.4em;\n      height: 100%;\n      position: absolute;\n      right: 0;\n      top: 0;\n      transform: translateX(50%);\n      z-index: 1;\n\n      touch-action: none;\n\n      &.isResizing {\n        background: rgb(88, 168, 218);\n      }\n    }\n  }\n  .item_selected {\n    // .td{\n    // text-decoration: underline;\n    font-weight: 550;\n    background-color: #426ca60c;\n    // }\n  }\n  .th {\n    text-align: center;\n  }\n\n  .td {\n    // font-style: italic;\n    font-weight: 400;\n  }\n}\n\n.project_list {\n  max-width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  background: #ffffff;\n  // margin-bottom: 5px;\n  background: #ffffff;\n  // border: 1px solid #58595d35;\n  border-bottom: 0;\n  position: relative;\n  &.scrollX {\n    overflow-x: auto;\n  }\n  tr:nth-child(even) {\n    // background-color: rgb(243, 242, 242);\n    background-color: rgb(233 241 251 / 40%);\n  }\n\n  tr:nth-child(odd) {\n    background-color: white;\n  }\n  tr:last-child {\n    td {\n      border-bottom: 0.02px solid #58595d4b;\n    }\n  }\n\n  tbody {\n    tr {\n      // &:hover {\n      //   background-color: #426ca62f;\n      // }\n\n      td {\n        height: 5em;\n      }\n    }\n  }\n  &:focus {\n    outline: none;\n  }\n}\n\n.project_list_kp {\n  max-width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  background: #ffffff;\n  margin-bottom: 5px;\n  background: #ffffff;\n  border: 1px solid #58595d35;\n  border-bottom: 0;\n  position: relative;\n  &.scrollX {\n    overflow-x: scroll;\n  }\n\n  .kpf_table_tr:hover {\n    background-color: #426ca62f;\n  }\n}\n.row-even {\n  background-color: rgb(233 241 251 / 40%);\n}\n\n.row-odd {\n  background-color: white;\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n}\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 15px rgba(103, 149, 187, 0.566);\n}\n::-webkit-scrollbar-thumb {\n  box-shadow: inset 0 0 15px rgba(103, 149, 187, 0.486);\n}\n.radio_container {\n  display: flex;\n  justify-content: center;\n}\n.circules_box {\n  width: 14px;\n  height: 14px;\n  position: relative;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n\n  .circule1 {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 14px;\n    width: 14px;\n    background-color: #eee;\n    border-radius: 50%;\n  }\n  .circule2 {\n    position: absolute;\n    top: 3.3px;\n    left: 3.3px;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n  }\n}\n\n.availability_circule_box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin: 0 10px;\n\n  & .outer_circle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    box-sizing: content-box;\n\n    width: 12px;\n    height: 12px;\n\n    border-radius: 50%;\n    background-color: white;\n    border: 1px solid #426ca65e;\n\n    & .inner_circle {\n      flex-shrink: 0;\n      width: 8px;\n      height: 8px;\n      border-radius: 50%;\n    }\n  }\n}\n\n.item_selected {\n  td {\n    text-decoration: underline;\n    font-weight: 550;\n  }\n}\n\ntd {\n  white-space: nowrap; /* Запрет переноса текста на новую строку */\n  overflow: hidden; /* Скрытие текста, выходящего за пределы ячейки */\n  text-overflow: ellipsis;\n}\n\n.table {\n  max-width: 48vw;\n  display: inline-block;\n  border-spacing: 0;\n  // border: 1px solid black;\n\n  .tr {\n    :last-child {\n      .td {\n        border-bottom: 0;\n      }\n    }\n  }\n\n  .th,\n  .td {\n    margin: 0;\n    padding: 0.5rem;\n    border-bottom: 1px solid black;\n    border-right: 1px solid black;\n    position: relative;\n\n    :last-child {\n      border-right: 0;\n    }\n\n    .resizer {\n      display: inline-block;\n      background: blue;\n      width: 5px;\n      height: 100%;\n      position: absolute;\n      right: 0;\n      top: 0;\n      transform: translateX(50%);\n      z-index: 1;\n\n      touch-action: none;\n\n      &.isResizing {\n        background: red;\n      }\n    }\n  }\n}\n\n.table_container {\n  max-width: 50vw;\n}\n\nthead {\n  width: 100%;\n  position: sticky;\n  height: auto;\n  top: 0;\n  background: white;\n  z-index: 50;\n  overflow: auto;\n  border-bottom: 0.01px solid #58595d4b;\n  border-collapse: separate;\n  th {\n    border-collapse: separate;\n    font-style: normal;\n    font-weight: 500;\n    color: #426ba6;\n    align-items: center;\n    text-align: center;\n\n    border-right: 0.01px solid #58595d4b;\n    border-bottom: 0.01px solid #58595d4b;\n    &:last-child {\n      border-right: 0;\n    }\n  }\n}\ntable {\n  thead {\n    border-collapse: separate;\n  }\n  tbody {\n    border-collapse: collapse;\n  }\n}\n\n.table_with_bb {\n  max-width: 100%;\n\n  overflow-x: scroll;\n  background: #ffffff;\n  margin-bottom: 5px;\n  background: #ffffff;\n  border: 1px solid #58595d35;\n  border-bottom: 0;\n  position: relative;\n\n  thead {\n    height: 1.5em;\n    tr {\n      background-color: #426ca62f;\n    }\n  }\n  table {\n    tr {\n      border-bottom: 1px solid #426ca63b;\n      &:hover {\n        background-color: #426ca62f;\n      }\n      &:last-child {\n        border-bottom: 0;\n      }\n    }\n  }\n}\n\n.table_dnd_container {\n  // max-width: 100%;\n\n  overflow-x: scroll;\n  // position: relative;\n  // overflow: scroll;\n\n  // background: #FFFFFF;\n  // margin-bottom: 5px;\n  // background: #FFFFFF;\n  // border: 1px solid #58595d35;\n  // border-bottom:0;\n  // position: relative;\n  // .project_table {\n  //   // overflow-x: scroll;\n  // }\n  .project_list {\n    overflow-x: scroll;\n  }\n}\n.table_xscroll__container {\n  .project_list {\n    overflow-x: auto;\n  }\n}\n\n.modal_form__child {\n  .project_list {\n    // display: flex;\n    // align-self: stretch;\n    // min-height: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
